<template>
  <div>
    <v-container fluid>
      <base-material-card icon="mdi-view-dashboard-variant" title="ศูนย์ติดตามงานพนักงานราชการ (ส่วนกลาง)" class="px-5 py-3">
        <v-alert type="info" outlined dense border="left" class="mb-3">
          ติดตามวงจรงานพนักงานราชการครบทุกขั้นตอน: กรอบอัตรากำลัง → ทะเบียนประวัติ/สัญญาจ้าง → การลา →
          ประเมินผล ปผ.พนร. (ปีละ 2 รอบ) → เลื่อนค่าตอบแทน → การย้าย → ลาออก/พ้นสภาพ
        </v-alert>
        <GovemLifecycleHub mode="national" link-base="admin" />
      </base-material-card>
    </v-container>
  </div>
</template>

<script>
import GovemLifecycleHub from "../../../components/govem/GovemLifecycleHub.vue";

export default {
  name: "GovemHub",
  components: { GovemLifecycleHub }
};
</script>
